import {apiCaller} from '@/api/apiCaller';
import {apihost} from '@/api/urls';
import {AxiosPromise} from 'axios';
import {Brand, FamilyVersion, Model, Tag, VehicleTypeOriginRange} from '../models';
import {ClassificationModelFilter} from '../models/filters';
import {CountryEnum} from '@/models/Enums';
import {buildDownloadFile} from '@/modules/neovehicle/services/services';

const getClassificationModels = (
  filter: ClassificationModelFilter,
): AxiosPromise<Model[]> =>
  apiCaller.getParams(
    `/neovehicle/classification/models`,
    apihost,
    filter,
  );

const getVehicleTypeOriginsRange = (): AxiosPromise<VehicleTypeOriginRange[]> =>
  apiCaller.get(`/neovehicle/vehicletypeoriginsrange`, apihost);

const getFamilies = (filter: {
  idBrand: number;
  idVehicleTypes: number[];
  country: CountryEnum;
}): AxiosPromise<FamilyVersion[]> =>
  apiCaller.getParams(`/neovehicle/models/families`, apihost, filter);

const saveClassification = (models: {
  idModels: number[];
  idBrand: number;
  idFamily: number;
  idFamilyGroup: number;
  idFamilyVersion: number;
  country: number;
  idVehicleTypes: number[];
  familyName: string | null | undefined;
  familyGroupName: string | null | undefined;
  familyVersionName: string | null | undefined;
}): AxiosPromise<void> =>
  apiCaller.put(
    `/neovehicle/classification/models`,
    apihost,
    models,
  );

const saveModel = (models: {
  idModels: number[];
  idBrand: number;
  country: number;
  idVehicleTypes: number[];
}): AxiosPromise<void> =>
  apiCaller.put(
    `/neovehicle/models`,
    apihost,
    models,
  );

const exportModels = (country: CountryEnum): Promise<any> =>
  apiCaller
    .getFile(`/neovehicle/models/export?country=${country}`, apihost)
    .then(buildDownloadFile(
      `relatorio_modelos_de_veiculos_${new Date().toISOString()}.xlsx`,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'));

export const modelService = {
  getClassificationModels,
  exportModels,
  getFamilies,
  saveClassification,
  saveModel,
  getVehicleTypeOriginsRange,
};
